// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20ppd","label":"styles_label__hZW4F"};